import { useTranslation } from 'next-i18next'

import { LeagueType } from '~/Leaderboard/types/leaderboard.types'
import ArrowDownBoldIcon from '~/components/Icons/svgs/ArrowDownBoldIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { NotificationMessage } from '~/shared/types/notification.types'

export default function EndOfLeagueNotification({ message }: { message: NotificationMessage }): React.ReactElement {
  const { t } = useTranslation('gamification')

  const isPromoted =
    message.new_league && message.previous_league ? message.new_league > message.previous_league : false

  const LeagueName = Object.entries(LeagueType)
    .filter(([, value]) => value === message.new_league)
    .map(([key]) => key)
    .toString()
    .toLowerCase()

  const badgeSrckey = `gamification/badges/league/${LeagueName}-badge.svg`

  return (
    <>
      <div className="flex relative py-2">
        {message.new_league !== message.previous_league && (
          <span className={`absolute ml-6 -mt-1 ${isPromoted ? 'rotate-180' : ''}`}>
            <SVGIcon
              icon={ArrowDownBoldIcon}
              pathClassName={isPromoted ? 'text-green-light-deep' : 'text-red'}
              size={25}
            />
          </span>
        )}
        <ResponsiveImage
          alt={t(`league.${LeagueName}`)}
          className="min-w-max px-5"
          fit="contain"
          height={75}
          imageWidths="56"
          srcKey={badgeSrckey}
          width={56}
        />
        <div className="flex flex-col w-full text-xl">
          <div className="flex flex-col">
            <h3 className="font-semibold text-md uppercase">{`
          ${
            message.new_league === message.previous_league ? t('bravo') : isPromoted ? t('congratulations') : t('ohNo')
          }!
        `}</h3>
            <p className="text-sm leading-normal">
              {message.new_league === message.previous_league ? (
                /* If staying in the same league*/ <>{`${t('youStayed')} `} </>
              ) : isPromoted ? (
                /* If Promoted to next league*/
                <>{t('advancing')} </>
              ) : (
                /* If demoted to previous league*/ <>
                  {t('youDemoted')}
                  <br />
                </>
              )}
              <span className="font-semibold">{t(`league.${LeagueName}`)}</span>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
